/**
 * @generated SignedSource<<10868a1b995c16aa53a1abbf409cc8cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightStatus_flight$data = {
  readonly expired: boolean;
  readonly " $fragmentType": "FlightStatus_flight";
};
export type FlightStatus_flight$key = {
  readonly " $data"?: FlightStatus_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightStatus_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightStatus_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expired",
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "7ecd608a8bfe1a535ff96c8c1a7bea05";

export default node;
